export default __webpack_public_path__ + "d4b4bff9976535bdbc3fe218f74a3e7e.png";